module.exports = __webpack_public_path__ + "img/Step1m.26ddfc37.png";